export const expressionHeaderText = "YWzv";
export const dexLitePaneHeaderShellPane = "ge3lv";
export const dictationHelpHeaderText = "a3ZV$b";
export default {expressionHeaderText,dexLitePaneHeaderShellPane,dictationHelpHeaderText};